import { lazy, type FC } from 'react';
import { useOptionalPublicSsoOfferCards } from 'src/apis/storage/use-optional-public-sso-offer-cards';
import { useOptionalStorageServiceRoot } from 'src/apis/storage/use-storage-service-root';
import type { OptionalStorageServiceRootRequest } from 'src/apis/storage/use-storage-service-root';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { NotFound } from 'src/utils/errors';

const Page = lazy(() => import('./page'));

export const StorageOfferCards: FC = () => {
  const storageServiceRoot = useOptionalStorageServiceRoot();

  if (storageServiceRoot?.loaded === false) {
    return <PageSpinner />;
  }

  if (!storageServiceRoot?.response?.data._links?.getSsoOfferCards) {
    throw new NotFound();
  }

  return <OfferCardsPage storageServiceRoot={storageServiceRoot} />;
};

const OfferCardsPage: FC<{
  storageServiceRoot: Successful<OptionalStorageServiceRootRequest>;
}> = ({ storageServiceRoot }) => {
  const ssoOfferCards = useOptionalPublicSsoOfferCards({ storageServiceRoot });

  if (!ssoOfferCards?.response) {
    return <PageSpinner />;
  }

  return <Page ssoOfferCards={ssoOfferCards} />;
};
